// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__c29O6","col":"Table_col__1H0Dg","fulfillmentStatus":"Table_fulfillmentStatus__1VOeV","emailCol":"Table_emailCol__2cmdj"};